export default __webpack_public_path__ + "452b4788784cedc7df323b36ed26bac8.png";